export const initSingleSelect = (elem, options = {}) => {
    const $select = $(elem)
    $select.selectize({
        ...options
    })
}
